import { baseNextjsUrl } from "@memorang/constants";

const ENDPOINT_SESSION_ANALYSIS = `${baseNextjsUrl}/api/ai/sessionAnalysis`;

const events = {
	viewReportClicked: "mem_view_report_clicked",
	fullReportViewed: "mem_full_report_viewed",
	readingTime: "mem_reading_time",
};
export { ENDPOINT_SESSION_ANALYSIS, events };
